<script setup>
const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routerParams = {
  name: 'inbox_conversation',
  params: { conversation_id: row.original.conversationId },
};
</script>

<template>
  <div class="text-right">
    <router-link
      :to="routerParams"
      target="_blank"
      class="hover:underline text-woot-500 dark:text-woot-500"
    >
      {{ `#${row.original.conversationId}` }}
    </router-link>
    <div
      v-tooltip="row.original.createdAt"
      class="text-slate-600 dark:text-slate-200 text-sm"
    >
      {{ row.original.createdAgo }}
    </div>
  </div>
</template>
